import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpResponse, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError, finalize } from 'rxjs/operators';
import { LoaderService } from '../services/loader.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DcnErrorComponent } from '../components/dcn-error/dcn-error.component';
import { SsoSecurityService } from '../services/sso-security.service';
import { UserService } from '../services/user.service';

@Injectable()
export class DcnEsignInterceptor implements HttpInterceptor {
    subscription: any;
    constructor(public loaderService: LoaderService,private route:Router,private authservice:SsoSecurityService,
        private userservice:UserService) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
       let load=false;
        this.loaderService.ad.subscribe(loadValue=>{
            load=loadValue;
        });
       
        if(load===false){ 
            this.loaderService.show();
            }

           
       let tokenheader=  this.authservice.getAuthorizationIdTokenHeaderValue();
       let upn=this.userservice.getObject("userPrincipalName");
       let re_auth_header=this.userservice.getObject("Reauthorization");
      
        
        if(tokenheader!==null){
        request = request.clone({ headers: request.headers.set( 'Authorization',  tokenheader)
        .set('userPrincipalName',  upn).set("Reauthorization",re_auth_header?re_auth_header:"")
        }); 
        }else{
            //this.authservice.logoutRedirect();
        }
         
        
        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                            
                   this.loaderService.hide();
                
                }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {
              
                this.loaderService.hide();
                this.loaderService.unload();
                if(error && error.status===401){
                   this.route.navigate(["/unauthorized"]);
                   }else
                    if(error.status!==401){
                        return throwError(error);
                   }
               
            }));
    }

   
}

